<!-- back button -->
<button class="pos-absolute top-0 left-0 m-t-6 m-l z-5 cursor-pointer"
        (click)="closeModal()"
        [attr.aria-label]="'Close Modal' | translate">
    <i class="icon-arrow-left va-m fs-5-m fs-6"
       aria-hidden="true"></i>
</button>

<exponea-stock-notification class="block m-t"
                            [model]="modalData" />
